"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_dates_1 = require("react-dates");

require("react-dates/lib/css/_datepicker.css");

var BB8Button_1 = __importDefault(require("./BB8Button"));

require("./BB8DateRangePicker.scss");

var BB8DateRangePicker =
/** @class */
function (_super) {
  __extends(BB8DateRangePicker, _super);

  function BB8DateRangePicker(props) {
    var _this = _super.call(this, props) || this;

    _this.handleShowPicker = function () {
      _this.setState({
        focusedInput: "startDate",
        shown: true
      });
    };

    _this.handleDateChange = function (_a) {
      var startDate = _a.startDate,
          endDate = _a.endDate;

      _this.setState({
        endDate: endDate ? endDate.endOf("day") : undefined,
        startDate: startDate ? startDate.startOf("day") : undefined
      });
    };

    _this.handleFocusChange = function (focusedInput) {
      return _this.setState({
        focusedInput: focusedInput
      });
    };

    _this.handleAppy = function () {
      var _a = _this.state,
          endDate = _a.endDate,
          startDate = _a.startDate;

      if (endDate && startDate && _this.props.onDatesChange) {
        _this.setState({
          shown: false
        }, function () {
          _this.props.onDatesChange(startDate, endDate);
        });
      }
    };

    _this.handleCancel = function () {
      _this.setState(function () {
        return {
          endDate: undefined,
          shown: false,
          startDate: undefined
        };
      });
    };

    _this.state = {
      endDate: props.initialEndDate,
      focusedInput: "startDate",
      shown: false,
      startDate: props.initialStartDate
    };
    return _this;
  }

  BB8DateRangePicker.prototype.render = function () {
    var _a = this.state,
        focusedInput = _a.focusedInput,
        startDate = _a.startDate,
        endDate = _a.endDate,
        shown = _a.shown;
    var startDateString = startDate && startDate.format("MM/DD/YYYY");
    var endDateString = endDate && endDate.format("MM/DD/YYYY");
    var isActive = this.props.isActive;
    return react_1.default.createElement("div", {
      className: "date-range-picker-container"
    }, this.props.triggerComponent ? react_1.default.cloneElement(this.props.triggerComponent, {
      onClick: this.handleShowPicker
    }) : react_1.default.createElement(BB8Button_1.default, {
      variant: isActive ? "contained" : "outlined",
      className: "date-range-picker-trigger",
      onClick: this.handleShowPicker,
      style: {
        height: "48px"
      }
    }, this.props.children), !shown ? null : react_1.default.createElement("div", {
      className: "date-range-picker-wrapper"
    }, react_1.default.createElement("div", {
      className: "date-range-picker-inputs"
    }, react_1.default.createElement("span", {
      id: "date-range-start-date"
    }, startDateString || "start date"), "-", react_1.default.createElement("span", {
      id: "date-range-end-date"
    }, endDateString || "end date")), react_1.default.createElement("div", {
      className: "date-range-picker-content"
    }, react_1.default.createElement(react_dates_1.DayPickerRangeController, {
      isFocused: shown,
      startDate: startDate || null,
      endDate: endDate || null,
      onDatesChange: this.handleDateChange,
      focusedInput: focusedInput,
      onFocusChange: this.handleFocusChange,
      numberOfMonths: 2,
      noBorder: true,
      hideKeyboardShortcutsPanel: true,
      keepOpenOnDateSelect: true,
      verticalHeight: 340
    })), react_1.default.createElement("div", {
      className: "date-range-picker-footer"
    }, react_1.default.createElement(BB8Button_1.default, {
      variant: "outlined",
      color: "default",
      onClick: this.handleCancel
    }, "Cancel"), react_1.default.createElement(BB8Button_1.default, {
      variant: "contained",
      color: "primary",
      onClick: this.handleAppy
    }, "Apply"))));
  };

  return BB8DateRangePicker;
}(react_1.default.Component);

exports.BB8DateRangePicker = BB8DateRangePicker;
exports.default = BB8DateRangePicker;